import { render, staticRenderFns } from "./SuccessPage.vue?vue&type=template&id=12d076f3&scoped=true"
import script from "./SuccessPage.vue?vue&type=script&lang=js"
export * from "./SuccessPage.vue?vue&type=script&lang=js"
import style0 from "./SuccessPage.vue?vue&type=style&index=0&id=12d076f3&prod&scoped=true&lang=scss"
import style1 from "./SuccessPage.vue?vue&type=style&index=1&id=12d076f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d076f3",
  null
  
)

export default component.exports